<template>
  <v-container>
    <v-data-table :headers="headers" :items="searches" sort-by="search_id">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title><span class="body-2 font-weight-medium">My Current Searches</span></v-toolbar-title>
          <v-spacer/>
          <v-dialog v-model="showDialog">
            <template v-slot:activator="{ on }">
              <v-btn text small outlined v-on="on"><span class="body-2 font-weight-medium">New</span></v-btn>
            </template>
            <v-form>
              <v-card>
                <v-card-text>
                  <!-- <v-text-field label="Search" v-model="editedSearch.search_string" clearable></v-text-field> -->
                  <v-text-field label="Search" v-model="searchString" clearable></v-text-field>
                  <!-- <v-text-field label="Search" :value="editedSearch.search_string" @input="updateMethod" clearable></v-text-field> -->
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click.stop="cancelEdit()">Cancel</v-btn>
                  <v-btn text :disabled="disableSaveButton" @click.stop="isUpdate ? editSearch(editedSearch) : saveSearch()">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.search_id="{ item }">
        <span @click.stop="$emit('searchSelected', item.search_id)" style="color: blue;">{{ item.search_id }}</span>
      </template>
      <template v-slot:item.search_string="{ item }">
        <span class="body-1">{{ item.search_string }}</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click.stop="overloadSaveDialog(item)">mdi-pencil</v-icon>
        <v-icon small @click.stop="deleteSearch(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <!-- <v-dialog v-model="showDialog" id="EditSearch">
      <v-form>
        <v-card>
          <v-card-text>
            <v-text-field label="Search" v-model="editedSearch.string"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn text @click.stop="cancelEdit()">Cancel</v-btn>
            <v-btn text :disabled="disableSaveButton" @click.stop="saveSearch(editedSearch)">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog> -->
  </v-container>
</template>

<script>
// import EditSearch from "../components/editSearch.vue"

// import Vue from "vue";

export default {
  name: "Searches",
  components: {
    // EditSearch
  },
  data () {
    return {
      showDialog: false,
      isUpdate: false,
      emptySearch: {
        search_id: -1,
        search_string: ""
      },
      editedIndex: -1,
      editedSearch: {
        search_id: -1,
        search_string: ""
      },
      headers: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "search_id"
        },
        {
          text: "Search",
          align: "left",
          sortable: false,
          value: "search_string"
        },
        {
          text: "Actions",
          value: "action",
          align: "center",
          sortable: false
        }
      ],
      searchString: "",
      searches: []
    }
  },
  methods: {
    overloadSaveDialog(search) {
      this.isUpdate = true
      this.showDialog = true

      this.editedIndex = this.searches.indexOf(search)
      this.editedSearch = search
      this.searchString = search.search_string
    }, /*
    updateMethod (event) {
      console.log(event)
      this.editedSearch.search_string = event
    }, */
    cancelEdit() {
      // console.log('Dialog resetting...') // debug
      this.isUpdate = false
      this.showDialog = false
      this.editedIndex = -1
      this.editedSearch = Object.assign({}, this.emptySearch)
      this.searchString = ""
    },
    editSearch(search) {
      this.editedIndex = this.searches.indexOf(search)
      this.editedSearch = Object.assign({}, search)
      this.showDialog = true

      // TODO : Add code to delete existing listings for old search string
      let params = {
        resource: "search_string",
        action: "update",
        variables: {
          user_id: this.$store.state.userId,
          guild_id: process.env.VUE_APP_GUILD_ID,
          search_id: search.search_id,
          search_string: this.searchString
        }
      }

      let url = `${process.env.VUE_APP_API_ROOT_URL}update/`

      let self = this
      this.axios.post(url, params)
      .then (function confirmUpdate (response) {
        // console.log(response) // debug
        let updateCount = response.data.update.update
        // console.log(updateCount) // debug

        if (updateCount >= 1) {
          self.searches[self.editedIndex].search_string = self.searchString
          self.cancelEdit()
        }
      })
    },
    deleteSearch(search) {
      // console.log(search) // debug
      let self = this
      this.editedIndex = this.searches.indexOf(search)
      // console.log(`component deleteSearch edited index ${this.editedIndex}`) // debug
      this.editedSearch = this.searches[this.editedIndex]
      // confirm choice to delete the record.
      // remove the record from the database
      let params = {
        resource: "search_string",
        action: "remove",
        variables: {
          user_id: this.$store.state.userId,
          search_id: this.editedSearch.search_id
        }
      }

      let url = `${process.env.VUE_APP_API_ROOT_URL}remove/`
      this.axios.post(url, params)
      .then (function confirmRemoval (response) {
        // console.log(response) // debug
        let changeCount = response.data.changes
        // console.log(`Delete count - ${changeCount}`) // debug
        if (changeCount > 0) {
          // dispatch action to remove search from store
          // self.$store.dispatch('deleteSearch', self.editedIndex)
          // remove search from local component
          self.searches.splice(self.editedIndex, 1)
          // reset the variables for storing edits
          self.editedIndex = -1
          self.editedSearch = self.emptySearch
        }
        // TODO : else clause for error handling?
      })
    },
    // saveSearch (search) {
    saveSearch() {
      let self = this

      // if (this.editedIndex > -1) {
        // Object.assign(this.searches[this.editedIndex], this.editedSearch)
        /* } else {
          this.searches.push(this.editedSearch) */
      // }
      // console.log(`Saving ${JSON.stringify(search)}`)
      let params = {
        resource: "search_string",
        action: "add",
        variables: {
          user_id: this.$store.state.userId,
          guild_id: process.env.VUE_APP_GUILD_ID,
          search_string: this.searchString
        }
      }
      let url = `${process.env.VUE_APP_API_ROOT_URL}save/`
      // close the dialog once the change is committed to the database
      this.axios.post(url, params)
      .then (function verifySave (response) {
        // console.log(response) // debug
        let searchId = response.data.search_id
        // console.log(`New search ID is ${searchId}`) // debug
        let search = {
          search_id: searchId,
          search_string: self.searchString
        }
        self.cancelEdit()
        // TODO : Add code to add new search string to local store
        // self.$store.dispatch('addSearch', search)
        self.searches.push(search)
      })
      // this.cancelEdit()
    },
    loadSearches() {
      let self = this
      let url = `${process.env.VUE_APP_API_ROOT_URL}searches/list/`
      let params = {
        resource: "search_string",
        action: "list",
        variables: {
          user_id: this.userId
        }
      }

      this.axios.post(url, params)
        .then (function storeSearches (response) {
          // let searches = response.data.searches
          // console.log(searches)
          // this.$store.commit("setUserSearches", searches)
          // return searches
          self.searches = response.data.searches
        })
        .catch (function searchError (err) {
          // add error handler for when API is down.
          // eslint-disable-next-line
          console.log(err)
        })
    }
  },
  computed: {
    disableSaveButton() {
      // console.log(`Disable save button edited index: ${this.editedIndex}`) // debug
      // console.log(`Disable save button edited search: ${JSON.stringify(this.editedSearch)}`) // debug
      /* if (this.isUpdate) {
        // use store searches for comparison
        let storeSearches = this.$store.state.userSearches
        let storeSearchString = storeSearches[this.editedIndex].search_string
        console.log(`Store search is ${storeSearchString}`)
        // return this.editedSearch.search_string.toLowerCase() == storeSearches[this.editedIndex].search_string.toLowerCase()
        return this.editedSearch.search_string.toLowerCase() == storeSearchString.toLowerCase()
      } else { */
      if (this.editedIndex > -1) {
        return this.searchString.toLowerCase() == this.searches[this.editedIndex].search_string.toLowerCase()
      } else if (this.searchString.length > 0) {
        return false
      } else {
        return true
      }
      /* } */

    },
    userId: {
      get() {
        return this.$store.state.userId
      }
    }
  },
  mounted() {
    let isAuthorized = this.$store.state.isAuthorized
    // console.log(`Authorized = ${isAuthorized}`) // debug
    if (isAuthorized) {
      // console.log('Loading searches...') // debug
      //this.$store.dispatch('loadSearches')
      this.loadSearches()
    }
  }
}
</script>

<style scoped></style>
